import colors from "@assets/colors";
import { CreateResponsiveStyle, DEVICE_SIZES, maxSize } from "rn-responsive-styles";

const useStyles = CreateResponsiveStyle(
  {
    drawer_guest_item_header: {
      height: 96,
      paddingTop: 10.5,
      flexDirection: "row",
      alignItems: "center",
      borderBottomWidth: 0.5,
      borderBottomColor: colors.border6,
      backgroundColor: colors.white,
    },
    drawer_item_header: {
      height: 96,
      paddingTop: 10.5,
      flexDirection: "row",
      alignItems: "center",
      borderBottomWidth: 0.5,
      borderBottomColor: colors.border6,
      backgroundColor: colors.offwhite4,
    },
    drawer_mobile_container: {
      flex: 1,
      paddingHorizontal: 10,
      flexWrap: "wrap",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },
    drawer_mobile_logo: {
      height: 42,
      width: 204,
      tintColor: colors.white,
    },
    v_height: { height: 30.75 },
  },
  {
    [DEVICE_SIZES.LG]: {
      drawer_item_header: { height: 81.75, paddingTop: 9 },
    },
    [maxSize(DEVICE_SIZES.MD)]: {
      drawer_item_header: {
        height: 75,
        paddingLeft: 20,
        paddingRight: 20,
        justifyContent: "flex-end",
        backgroundColor: colors.white,
        borderBottomWidth: 0,
      },
    },
  }
);

export default useStyles;
